module.exports = __webpack_public_path__ + "static/media/voxlogo.b3ea8688.webp";